module.exports = __webpack_public_path__ + "static/media/veado_thumb.7b3ff58c.jpg";